/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull frontend'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 16
 * Build: 1.0.0
 * Runtime: browser:javascript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/formplus/Formplus%20Localhost/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/formplus/Formplus%20Localhost/implementation/frontend)
 */

import * as amplitude from '@amplitude/analytics-browser';

/**
 * @typedef BaseEvent
 * @type {object}
 * @property {string} event_type
 * @property {Object.<string, *>} [event_properties]
 */

/**
 * @typedef Plan
 * @type {object}
 * @property {string} [branch]
 * @property {string} [source]
 * @property {string} [version]
 * @property {string} [versionId]
 */

/**
 * @typedef LoadClientOptions
 * @type {object}
 * @property {string} [apiKey]
 * @property {Object} [configuration]
 * @property {BrowserClient} [instance]
 */

/**
 * @typedef LoadOptions
 * @type {object}
 * @property {'formpluslocalhost'} [environment]
 * @property {boolean} [disabled]
 * @property {LoadClientOptions} [client]
 */

/**
 * @typedef {Object} EventOptions
 * @type {object}
 */

/**
 * @typedef ApiKey
 * @type {object}
 * @property {string} formpluslocalhost
 */
export const ApiKey = {
  formpluslocalhost: '87c69de007ff2f4caa204837d229849e'
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration = {
  plan: {
    version: '16',
    branch: 'main',
    source: 'frontend',
    versionId: '8eedf596-7389-4b22-bf76-7b8d15c338cb'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-javascript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export class Identify {
  constructor(properties) {
    this.event_type = amplitude.Types.SpecialEventType.IDENTIFY;
    this.event_properties = properties;
  }
}

export class BuilderTutorialIsCompleted {
  constructor() {
    this.event_type = 'Builder Tutorial Is Completed';
  }
}

export class BuilderTutorialIsSkipped {
  constructor() {
    this.event_type = 'Builder Tutorial Is Skipped';
  }
}

export class BuilderTutorialIsStarted {
  constructor() {
    this.event_type = 'Builder Tutorial Is Started';
  }
}

export class FormCreationIsStarted {
  constructor(properties) {
    this.event_type = 'Form Creation Is Started';
    this.event_properties = properties;
  }
}

export class NextToCustomisePageIsClicked {
  constructor(properties) {
    this.event_type = 'Next to Customise Page Is Clicked';
    this.event_properties = properties;
  }
}

export class NextToResponsesPageIsClicked {
  constructor(properties) {
    this.event_type = 'Next to Responses Page Is Clicked';
    this.event_properties = properties;
  }
}

export class NextToSettingsPageIsClicked {
  constructor(properties) {
    this.event_type = 'Next to Settings Page Is Clicked';
    this.event_properties = properties;
  }
}

export class NextToSharePageIsClicked {
  constructor(properties) {
    this.event_type = 'Next to Share Page Is Clicked';
    this.event_properties = properties;
  }
}

export class ResponsesFileManagementIsClicked {
  constructor(properties) {
    this.event_type = 'Responses File Management Is Clicked';
    this.event_properties = properties;
  }
}

export class ResponsesPagePartialSubmissionIsClicked {
  constructor(properties) {
    this.event_type = 'Responses Page Partial Submission Is Clicked';
    this.event_properties = properties;
  }
}

export class ResponsesPageReportIsClicked {
  constructor(properties) {
    this.event_type = 'Responses Page Report Is Clicked';
    this.event_properties = properties;
  }
}

/**
 * @typedef PromiseResult
 * @type {object}
 * @property {Promise|undefined} promise
 */

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  constructor() {
    /* @type {BrowserClient|undefined} */
    this.amplitude = undefined;
    this.disabled = false;
  }

  /**
   * @return {BrowserClient}
   */
  get client() {
    this.isInitializedAndEnabled();
    return this.amplitude;
  }

  /**
   * @return {boolean}
   */
  get isLoaded() {
    return this.amplitude != null;
  }

  /**
   * @private
   * @return {boolean}
   */
  isInitializedAndEnabled() {
    if (!this.isLoaded) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param {LoadOptions} options Configuration options to initialize the Ampli SDK with. 'environment', 'client.apiKey' or 'client.instance' is required.
   *
   * @return {PromiseResult}
   */
  load(options) {
    this.disabled = options?.disabled ?? false;

    if (this.isLoaded) {
      console.warn('WARNING: Ampli is already initialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey;
    if (options?.client?.apiKey) {
      apiKey = options.client.apiKey;
    } else if (options?.environment) {
      apiKey = ApiKey[options.environment];
    }

    if (options?.client?.instance) {
      this.amplitude = options?.client?.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...options?.client?.configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set or update that user's properties.
   *
   * @param {string|undefined} userId The user's id.
   * @param {Object} [properties] The user's properties.
   * @param {string} [properties.accountCreationDate] Property has no description in tracking plan.
   * @param {string} [properties.email] Property has no description in tracking plan.
   * @param {string} [properties.firstSubscriptionDate] Property has no description in tracking plan.
   * @param {string} [properties.formplusUserId] Property has no description in tracking plan.
   * @param {number} [properties.formsCount] Property has no description in tracking plan.
   * @param {boolean} [properties.hasTeam] Property has no description in tracking plan.
   * @param {boolean} [properties.industry] Property has no description in tracking plan.
   * @param {string} [properties.lastDateOfSubscriptionRenewal] Property has no description in tracking plan.
   * @param {string} [properties.lastLoginTime] Property has no description in tracking plan.
   * @param {string} [properties.name] Property has no description in tracking plan.
   * @param {'Platinum'|'Enterprise'|'Starter'|'Professional'} [properties.oldSubscriptionPlanName] Property has no description in tracking plan.
   * @param {'Monthly'|'Annually'} [properties.oldSubscriptionPlanType] Property has no description in tracking plan.
   * @param {string} [properties.phoneNumber] Property has no description in tracking plan.
   * @param {boolean} [properties.signedUpViaTeam] Property has no description in tracking plan.
   * @param {'Google'|'Email'} [properties.signUpMethod] Property has no description in tracking plan.
   * @param {boolean} [properties.subscriptionCancellationStatus] Property has no description in tracking plan.
   * @param {'Platinum'|'Enterprise'|'Starter'|'Professional'} [properties.subscriptionPlanName] Property has no description in tracking plan.
   * @param {'Monthly'|'Annually'} [properties.subscriptionPlanType] Property has no description in tracking plan.
   * @param {string} [properties.subscriptionRenewalDate] Property has no description in tracking plan.
   * @param {number} [properties.teamsCount] Property has no description in tracking plan.
   * @param {string} [properties.trialSubscriptionExpirationDate] Property has no description in tracking plan.
   * @param {boolean} [properties.verified] Property has no description in tracking plan.
   * @param {EventOptions} [options] Optional event options.
   *
   * @return {PromiseResult}
   */
  identify(userId, properties, options) {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options, user_id: userId};
    }

    const ampIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        ampIdentify.set(key, value);
      }
    }
    return this.amplitude.identify(ampIdentify, options);
  }

  /**
  * Flush the event.
  */
  flush() {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude.flush();
  }

  /**
   * Track event
   *
   * @param {BaseEvent} event The event to track.
   * @param {EventOptions} [options] Optional event options.
   *
   * @return {PromiseResult}
   */
  track(event, options) {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude.track(event, undefined, options);
  }

  /**
   * Builder Tutorial Is Completed
   *
   * [View in Tracking Plan](https://data.amplitude.com/formplus/Formplus%20Localhost/events/main/latest/Builder%20Tutorial%20Is%20Completed)
   *
   * This event tracks when a user completes the builder onboarding tour.
   *
   * Owner: Busayo Longe
   *
   * @param {EventOptions} [options] Options for this track call.
   */
  builderTutorialIsCompleted(options) {
    return this.track(new BuilderTutorialIsCompleted(), options);
  }

  /**
   * Builder Tutorial Is Skipped
   *
   * [View in Tracking Plan](https://data.amplitude.com/formplus/Formplus%20Localhost/events/main/latest/Builder%20Tutorial%20Is%20Skipped)
   *
   * This event tracks when a user skips the builder onboarding tour.
   *
   * Owner: Busayo Longe
   *
   * @param {EventOptions} [options] Options for this track call.
   */
  builderTutorialIsSkipped(options) {
    return this.track(new BuilderTutorialIsSkipped(), options);
  }

  /**
   * Builder Tutorial Is Started
   *
   * [View in Tracking Plan](https://data.amplitude.com/formplus/Formplus%20Localhost/events/main/latest/Builder%20Tutorial%20Is%20Started)
   *
   * This event tracks when a user starts the builder onboarding tour.
   *
   * Owner: Busayo Longe
   *
   * @param {EventOptions} [options] Options for this track call.
   */
  builderTutorialIsStarted(options) {
    return this.track(new BuilderTutorialIsStarted(), options);
  }

  /**
   * Form Creation Is Started
   *
   * [View in Tracking Plan](https://data.amplitude.com/formplus/Formplus%20Localhost/events/main/latest/Form%20Creation%20Is%20Started)
   *
   * This event tracks when a user starts the process of form creation.
   *
   * Owner: Busayo Longe
   *
   * @param {Object} properties The event's properties.
   * @param {'Welcome Modal'|'Dashboard'} properties.newFormSource Property has no description in tracking plan.
   * @param {'Template'|'Blank'} properties.newFormType Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  formCreationIsStarted(properties, options) {
    return this.track(new FormCreationIsStarted(properties), options);
  }

  /**
   * Next to Customise Page Is Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/formplus/Formplus%20Localhost/events/main/latest/Next%20to%20Customise%20Page%20Is%20Clicked)
   *
   * This event tracks when user navigates from the builder page to customise page.
   *
   * Owner: Busayo Longe
   *
   * @param {Object} properties The event's properties.
   * @param {string} properties.formId Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  nextToCustomisePageIsClicked(properties, options) {
    return this.track(new NextToCustomisePageIsClicked(properties), options);
  }

  /**
   * Next to Responses Page Is Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/formplus/Formplus%20Localhost/events/main/latest/Next%20to%20Responses%20Page%20Is%20Clicked)
   *
   * This event tracks when user navigates from the customise page to settings page.
   *
   * @param {Object} properties The event's properties.
   * @param {string} properties.formId Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  nextToResponsesPageIsClicked(properties, options) {
    return this.track(new NextToResponsesPageIsClicked(properties), options);
  }

  /**
   * Next to Settings Page Is Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/formplus/Formplus%20Localhost/events/main/latest/Next%20to%20Settings%20Page%20Is%20Clicked)
   *
   * This event tracks when user navigates from the customise page to settings page.
   *
   * Owner: Busayo Longe
   *
   * @param {Object} properties The event's properties.
   * @param {string} properties.formId Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  nextToSettingsPageIsClicked(properties, options) {
    return this.track(new NextToSettingsPageIsClicked(properties), options);
  }

  /**
   * Next to Share Page Is Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/formplus/Formplus%20Localhost/events/main/latest/Next%20to%20Share%20Page%20Is%20Clicked)
   *
   * This event tracks when user navigates from the customise page to settings page.
   *
   * @param {Object} properties The event's properties.
   * @param {string} properties.formId Property has no description in tracking plan.
   * @param {string[]} properties.sharePageSettingsUsed Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  nextToSharePageIsClicked(properties, options) {
    return this.track(new NextToSharePageIsClicked(properties), options);
  }

  /**
   * Responses File Management Is Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/formplus/Formplus%20Localhost/events/main/latest/Responses%20File%20Management%20Is%20Clicked)
   *
   * This event tracks when the file management button on the responses page is clicked.
   *
   * Owner: Busayo Longe
   *
   * @param {Object} properties The event's properties.
   * @param {string} properties.formId Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  responsesFileManagementIsClicked(properties, options) {
    return this.track(new ResponsesFileManagementIsClicked(properties), options);
  }

  /**
   * Responses Page Partial Submission Is Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/formplus/Formplus%20Localhost/events/main/latest/Responses%20Page%20Partial%20Submission%20Is%20Clicked)
   *
   * This event tracks when the file partial submission button on the responses page is clicked.
   *
   * Owner: Busayo Longe
   *
   * @param {Object} properties The event's properties.
   * @param {string} properties.formId Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  responsesPagePartialSubmissionIsClicked(properties, options) {
    return this.track(new ResponsesPagePartialSubmissionIsClicked(properties), options);
  }

  /**
   * Responses Page Report Is Clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/formplus/Formplus%20Localhost/events/main/latest/Responses%20Page%20Report%20Is%20Clicked)
   *
   * This event tracks when a user navigates from the share page to the responses page.
   *
   * Owner: Busayo Longe
   *
   * @param {Object} properties The event's properties.
   * @param {string} properties.formId Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  responsesPageReportIsClicked(properties, options) {
    return this.track(new ResponsesPageReportIsClicked(properties), options);
  }
}

export const ampli = new Ampli();
